import { useEffect, useState, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../hooks/redux'
import { loginWithGoogle } from '../store/slices/authSlice'

const GoogleCallback = () => {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const [isProcessing, setIsProcessing] = useState(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const hasProcessed = useRef(false)

  useEffect(() => {
    // 防止重複執行
    if (hasProcessed.current || isProcessing) {
      console.log('Google Callback: Already processed or processing, skipping')
      return
    }
    
    hasProcessed.current = true
    setIsProcessing(true)

    const code = searchParams.get('code')
    const errorParam = searchParams.get('error')
    const state = searchParams.get('state')
    
    console.log('Google Callback processing:', { 
      code: code ? `${code.substring(0, 10)}...` : null, 
      error: errorParam, 
      state,
      hasProcessed: hasProcessed.current,
      isProcessing 
    })
    
    if (errorParam) {
      setError(`Google 授權失敗: ${errorParam}`)
      setTimeout(() => {
        navigate('/login')
      }, 3000)
      return
    }
    
    if (code) {
      // 使用 Redux action 來處理 Google 登入
      dispatch(loginWithGoogle(code))
        .unwrap()
        .then(() => {
          // 登入成功，重新導向到原本要去的頁面或首頁
          const redirectTo = state ? decodeURIComponent(state) : '/'
          console.log('Google login successful, redirecting to:', redirectTo)
          navigate(redirectTo, { replace: true })
        })
        .catch((error) => {
          console.error('Google login failed:', error)
          setError(error.message || 'Google 登入失敗')
          setTimeout(() => {
            navigate('/login')
          }, 3000)
        })
        .finally(() => {
          setIsProcessing(false)
        })
    } else {
      setError('缺少授權碼')
      setTimeout(() => {
        navigate('/login')
      }, 3000)
      setIsProcessing(false)
    }
  }, [])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-red-600 mb-4">
            <svg className="w-16 h-16 mx-auto mb-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">登入失敗</h2>
          <p className="text-gray-600">{error}</p>
          <p className="text-sm text-gray-500 mt-2">3 秒後自動返回登入頁面...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">正在處理 Google 登入...</p>
      </div>
    </div>
  )
}

export default GoogleCallback